import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DsMessageModule, DsMessageTone } from '@bmw-ds/components';

@Component({
  selector: 'cdf-message',
  imports: [DsMessageModule],
  template: `
    @if (displayMessage()) {
      <ds-message [tone]="tone()" [isDismissable]="false" [messageText]="text()" />
    }
  `,
  styleUrl: './message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageComponent {
  readonly displayMessage = input<boolean>(true);
  readonly tone = input<DsMessageTone>('caution');
  readonly text = input.required<string>();
}
